<div data-cy="service-level-agreement-modal__page" mat-dialog-title>
  <div class="row">
    <div class="col-md-9">
      <h4>{{ 'complaints.service_level.label' | transloco | capitaliz }}</h4>
    </div>
    <div class="col-md-3">
      <button data-cy="service-level-agreement-modal__close-btn" type="button" class="close no-margin" [matTooltip]="'close' | transloco | capitaliz" (click)="close()">
        <span aria-hidden="true"><mat-icon class="d-text-middle">close</mat-icon></span>
        <span class="sr-only">Close</span>
      </button>
    </div>
  </div>
</div>

<form data-cy="service-level-agreement-modal__form-form" #form="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content *transloco="let t">
    <table class="table table-borderless">
      <thead>
        <tr>
          <th>{{ 'complaints.service_level.priority' | transloco | capitaliz }}</th>
          <th>{{ 'complaints.service_level.resolution_time' | transloco | capitaliz }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="vertical-center">{{ 'complaints.service_level.priority_label_urgent' | transloco | capitaliz }}
          </th>
          <td>
            <div class="d-flex align-items-center">
              <mat-form-field class="w-100" appearance="fill">
                <input data-cy="service-level-agreement-modal__urgent-input" matInput type="number" name="Urgent" inputmode="numeric" min="0"
                  [placeholder]="'complaints.service_level.time' | transloco | capitaliz"
                  [(ngModel)]="priority.sla.priorities.urgent" required />
              </mat-form-field>
              <span class="ml-20 shrink-0">{{ 'complaints.service_level.time' | transloco | capitaliz }}</span>
            </div>
          </td>
        </tr>

        <tr>
          <th class="vertical-center">{{ 'complaints.service_level.priority_label_high' | transloco | capitaliz }}</th>
          <td>
            <div class="d-flex align-items-center">
              <mat-form-field class="w-100" appearance="fill">
                <input data-cy="service-level-agreement-modal__high-input" matInput type="number" name="High" inputmode="numeric" min="0"
                  [placeholder]="'complaints.service_level.time' | transloco | capitaliz"
                  [(ngModel)]="priority.sla.priorities.high" required />
              </mat-form-field>
              <span class="ml-20 shrink-0">{{ 'complaints.service_level.time' | transloco | capitaliz }}</span>
            </div>
          </td>
        </tr>

        <tr>
          <th class="vertical-center">{{ 'complaints.service_level.priority_label_medium' | transloco | capitaliz }}
          </th>
          <td>
            <div class="d-flex align-items-center">
              <mat-form-field class="w-100" appearance="fill">
                <input data-cy="service-level-agreement-modal__medium-input" matInput type="number" name="Medium" inputmode="numeric" min="0"
                  [placeholder]="'complaints.service_level.time' | transloco | capitaliz"
                  [(ngModel)]="priority.sla.priorities.medium" required />
              </mat-form-field>
              <span class="ml-20 shrink-0">{{ 'complaints.service_level.time' | transloco | capitaliz }}</span>
            </div>
          </td>
        </tr>

        <tr>
          <th class="vertical-center">{{ 'complaints.service_level.priority_label_low' | transloco | capitaliz }}</th>
          <td>
            <div class="d-flex align-items-center">
              <mat-form-field class="w-100" appearance="fill">
                <input data-cy="service-level-agreement-modal__low-input" matInput type="number" name="Low" inputmode="numeric" min="0"
                  [placeholder]="'complaints.service_level.time' | transloco | capitaliz"
                  [(ngModel)]="priority.sla.priorities.low" required />
              </mat-form-field>
              <span class="ml-20 shrink-0">{{ 'complaints.service_level.time' | transloco | capitaliz }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div mat-dialog-actions *transloco="let t" class="justify-content-end">
    <button data-cy="service-level-agreement-modal__close-btn-2" type="button" mat-stroked-button class="text-capitalize pull-right mt-10" (click)="close()">
      {{ t('close') | capitaliz }}
    </button>
    <button data-cy="service-level-agreement-modal__submit-btn" type="submit" mat-flat-button class="text-capitalize pull-right ml-10 mt-10" [disabled]="form.invalid">
      {{ t('save') | capitaliz }}
    </button>
  </div>
</form>
